export default __webpack_public_path__ + "static/media/logo.3b931fc4.svg";